import React from "react";
import { Button, Col, Row, Table, Switch } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus, FaPencilAlt, FaRegTrashAlt } from "react-icons/fa";
import { Panel, PanelHeader, PanelBody } from "../../../../util/panel";
import { axios, getToken, URL_API } from "../../../../../utils";
import { Link } from "react-router-dom";
import { useApi } from "../../../../../hooks/http2";
import {
  actionMKTProduct,
  searchSelector,
} from "../../../../../redux/slices/marketing/product";
import { AlertConfirm, AlertError, AlertSuccess } from "../../../../util/Alert";
import useAsync from "../../../../../utils/useAsync";
import manageWebsiteService from "../../../../../services/manage-website.service";
import { notFoundImg } from "../../utils/constants/mwHomeConstants";

export default function BannerList({ history, match }) {
  const dispatch = useDispatch();
  const search = useSelector(searchSelector);
  const { SET_SEARCH } = actionMKTProduct;
  const list = useApi(
    {
      baseURL: URL_API,
      url: "/manage-website/home/banner",
      params: {
        ...search,
        offset: (search.page - 1) * search.limit,
      },
      token: true,
    },
    [search]
  );

  const { execute: getHomeBannerAll , data:homeDataList } = useAsync(
    manageWebsiteService.getHomeBannerAll,
    {
      immediate:true,
    }
  );

  const { execute: deleteHomeBannerById } = useAsync(
    manageWebsiteService.deleteHomeBannerById,
    {
      onSuccess: async () => {
        await AlertSuccess("ลบข้อมูลสำเร็จ");
        await getHomeBannerAll();
      },
      onFailed: () => {
        AlertError();
      },
    }
  );

  const handleChangeStatus = (checked, id) => {
    axios({
      method: "post",
      baseURL: URL_API,
      url: `/manage-website/home/banner/${id}/status`,
      headers: { Authorization: "Bearer " + getToken() },
      data: {
        status: checked ? "active" : "inactive",
      },
    })
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Panel>
        <PanelHeader>Banner</PanelHeader>
        <PanelBody>
          <Row type="flex" justify="end" gutter={16} className="mb-4">
            <Col>
              <Button
                type="primary"
                onClick={() => history.push(`${match.path}/add`)}
              >
                <FaPlus className="mr-2"/>เพิ่มข้อมูล
              </Button>
            </Col>
          </Row>
          <Table
            bordered
            size="small"
            loading={list?.loading}
            dataSource={homeDataList || []}
            rowKey="id"
            pagination={{
              size: "default",
              showLessItems: true,
              showTotal: (total, range) =>
                `${range[0]} - ${range[1]} of ${total}`,
              total: list?.fetch?.total || 0,
              current: search.page,
              pageSize: search.limit,
              onChange: (page) => dispatch(SET_SEARCH({ page: page })),
            }}
          >
            <Table.Column
              title="No."
              key="no"
              align="center"
              dataIndex="row_id"
            />
            <Table.Column
              title="Desktop"
              key="desktop-images"
              align="center"
              dataIndex="desktop_url"
              render={(text) => (
                <img
                  src={text === null ? notFoundImg : text}
                  alt="desktop"
                  width="150px"
                  style={{ borderRadius: "3px" }}
                />
              )}
            />
            <Table.Column
              title="Mobile"
              key="mobile-images"
              align="center"
              dataIndex="mobile_url"
              render={(text) => (
                <img
                  src={text === null ? notFoundImg : text}
                  alt="mobile"
                  width="150px"
                  style={{ borderRadius: "3px" }}
                />
              )}
            />
            <Table.Column
              title="Public Status"
              key="public_status"
              dataIndex="status"
              align="center"
              render={(text, { id }) => (
                <Switch
                  defaultChecked={text === "active"}
                  onClick={(checked) => handleChangeStatus(checked, id)}
                />
              )}
            />

            <Table.Column
              title="Update Date"
              key="update_date"
              dataIndex="update_date"
              align="center"
              render={(text) =>
                text ? moment(text).format("DD/MM/YYYY HH:mm") : ""
              }
            />
            <Table.Column
              title="Manage"
              key="manage"
              align="center"
              render={(text, { id }) => (
                <Row>
                  <Link to={`${match.path}/${id}`}>
                    <Button type="primary">
                      <FaPencilAlt />
                    </Button>
                  </Link>
                  <Button
                    className="btn-danger ml-1"
                    onClick={async () => {
                      const confirm = await AlertConfirm("ลบข้อมูล");
                      if (confirm) {
                        deleteHomeBannerById(id);
                      }
                    }}
                  >
                    <FaRegTrashAlt />
                  </Button>
                </Row>
              )}
            />
          </Table>
        </PanelBody>
      </Panel>
    </>
  );
}
